import { Injectable, Optional, SkipSelf } from '@angular/core';
import { NPX_COOKIE_TIMEZONE_NAME, NPX_COOKIE_LOCALE_NAME, NPX_COOKIE_LOCALE_TIMEZONE_NAME } from './npx-locale-cookies';
import { NpCookieUtils } from '../../../../../newpla-modules-ng17/code_newpla';

const MAX_AGE_SECONDS = 1000 * 60 * 60 * 24;

@Injectable()
export class NpLocaleService {

  private _browserLocale: string;

  get browserLocale(): string {
    return this._browserLocale
  }


  private _browserTimeZone: string;

  get browserTimeZone(): string {
    return this._browserTimeZone
  }

  private _cookielocale: string;

  get cookieLocale(): string {
    return this._cookielocale;
  }

  setCookieLocale(locale: string) {
    this._cookielocale = locale;
    this.updateCookies();
  }

  private _cookieTimeZone: string;

  get cookieTimeZone(): string {
    return this._cookieTimeZone;
  }

  setCookieTimeZone(timeZone: string) {
    this._cookieTimeZone = timeZone;
    this.updateCookies()

  }

  // private router: Router,     @Inject(DOCUMENT) private document: Document
  constructor(@Optional() @SkipSelf() otherInstance: NpLocaleService) {
    if (otherInstance) throw 'LocaleService should have only one instance.';

    this._browserLocale = navigator.language;
    this._browserTimeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;

    const cookieLocale = NpCookieUtils.getCookie(NPX_COOKIE_LOCALE_NAME);
    this._cookielocale = cookieLocale ? cookieLocale : this._browserLocale;

    const cookieTimeZone = NpCookieUtils.getCookie(NPX_COOKIE_TIMEZONE_NAME);
    this._cookieTimeZone = cookieTimeZone ? cookieTimeZone : this._browserTimeZone;

    this.updateCookies();
  }

  updateCookies() {

    if (this.cookieLocale) {
      NpCookieUtils.setCookie(NPX_COOKIE_LOCALE_NAME, this.cookieLocale, MAX_AGE_SECONDS);
    } else {
      NpCookieUtils.deleteCookie(NPX_COOKIE_LOCALE_NAME);
    }

    if (this.cookieTimeZone) {
      NpCookieUtils.setCookie(NPX_COOKIE_TIMEZONE_NAME, this.cookieTimeZone, MAX_AGE_SECONDS);
    } else {
      NpCookieUtils.deleteCookie(NPX_COOKIE_TIMEZONE_NAME);
    }

    // 브라우저 타임존 전송
    // if (this.cookieLocale && this._browserTimeZone) {
    //   NpCookieUtils.setCookie(NPX_CLIENT_LOCALE_TIMEZONE_NAME, `${this.cookieLocale}/${this._browserTimeZone}`, TIME);
    // } else {
    //   NpCookieUtils.deleteCookie(NPX_CLIENT_LOCALE_TIMEZONE_NAME);
    // }

    // 쿠키 타임존 전송
    if (this.cookieLocale && this.cookieTimeZone) {
      NpCookieUtils.setCookie(NPX_COOKIE_LOCALE_TIMEZONE_NAME, `${this.cookieLocale}/${this.cookieTimeZone}`, MAX_AGE_SECONDS);
    } else {
      NpCookieUtils.deleteCookie(NPX_COOKIE_LOCALE_TIMEZONE_NAME);
    }

  }

}
